(function () {
  'use strict';

  var BADGES = {
    /* ── ATTARS — new scents (2026-09-24) ── */
    'sweet-oud-attar-3ml':     { status: 'SWEET',   statusColor: '#7A4A2A', scent: 'OIL · BASE', color: '#8a5c3a' },
    'sweet-oud-attar-8ml':     { status: 'SWEET',   statusColor: '#7A4A2A', scent: 'OIL · BASE', color: '#8a5c3a' },
    'wazir-oud-attar-3ml':     { status: 'ROYAL',   statusColor: '#412402', scent: 'OIL · BASE', color: '#7a4a2e' },
    'wazir-oud-attar-8ml':     { status: 'ROYAL',   statusColor: '#412402', scent: 'OIL · BASE', color: '#7a4a2e' },
    'shagaf-oud-attar-3ml':    { status: 'PASSION', statusColor: '#791F1F', scent: 'OIL · BASE', color: '#8a4a3a' },
    'shagaf-oud-attar-8ml':    { status: 'PASSION', statusColor: '#791F1F', scent: 'OIL · BASE', color: '#8a4a3a' },
    'kesar-chandan-attar-3ml': { status: 'SACRED',  statusColor: '#BA7517', scent: 'OIL · BASE', color: '#8a5c2e' },
    'kesar-chandan-attar-8ml': { status: 'SACRED',  statusColor: '#BA7517', scent: 'OIL · BASE', color: '#8a5c2e' },
    'tuberose-attar-3ml':      { status: 'PETAL',   statusColor: '#993556', scent: 'OIL · BASE', color: '#9b6b7a' },
    'tuberose-attar-8ml':      { status: 'PETAL',   statusColor: '#993556', scent: 'OIL · BASE', color: '#9b6b7a' },
    'white-musk-attar-3ml':    { status: 'PURE',    statusColor: '#7A6B58', scent: 'OIL · BASE', color: '#9b8a7a' },
    'white-musk-attar-8ml':    { status: 'PURE',    statusColor: '#7A6B58', scent: 'OIL · BASE', color: '#9b8a7a' },
    /* ── SPRAY PERFUMES 100ml ── */
    'liberte-100ml':      { status: 'ELEGANT', statusColor: '#854F0B', scent: 'FRESH · FLORAL',    color: '#8a6f2e' },
    'noir-100ml':         { status: 'DARK',    statusColor: '#2C2C2A', scent: 'DARK · OUD',        color: '#7a5230' },
    'voyage-100ml':       { status: 'BREEZY',  statusColor: '#0F6E56', scent: 'FRESH · WOODS',     color: '#3d6b58' },
    'white-oud':          { status: 'EARTHY',  statusColor: '#633806', scent: 'WOODY · FLORAL',    color: '#7a6558' },
    'million-gold-100ml': { status: 'RICH',    statusColor: '#BA7517', scent: 'SPICY · ORIENTAL',  color: '#8a5c2e' },
    'vanilla':            { status: 'COZY',    statusColor: '#993C1D', scent: 'WARM · GOURMAND',   color: '#9b7340' },
    'limitless':          { status: 'BOLD',    statusColor: '#27500A', scent: 'FRESH · AROMATIC',  color: '#4a7a5c' },
    'aqua':               { status: 'OCEAN',   statusColor: '#0C447C', scent: 'FRESH · AQUATIC',   color: '#3a6b8a' },
    'floral':             { status: 'BLOOM',   statusColor: '#993556', scent: 'PURE · FLORAL',     color: '#9b6b7a' },
    'ultra-male':         { status: 'STRONG',  statusColor: '#185FA5', scent: 'BOLD · FOUGERE',    color: '#5c4a7a' },
    'blue':               { status: 'CLEAN',   statusColor: '#085041', scent: 'CLEAN · FRESH',     color: '#3d6b8a' },
    'intense':            { status: 'SMOKY',   statusColor: '#791F1F', scent: 'DARK · INTENSE',    color: '#5c3d2e' },
    'oriental-100ml':     { status: 'EXOTIC',  statusColor: '#534AB7', scent: 'RICH · ORIENTAL',   color: '#8a3d5c' },
    'fabulous':           { status: 'VIBRANT', statusColor: '#D85A30', scent: 'FLORAL · WOODY',    color: '#8a5c6b' },
    'french-oud-100ml':   { status: 'WOODY',   statusColor: '#412402', scent: 'ROSE · OUD',        color: '#7a4a2e' },
    'code':               { status: 'SWEET',   statusColor: '#D4537E', scent: 'FLORAL · ORIENTAL', color: '#8a4a7a' },

    /* ── SPRAY PERFUMES 30ml (Kankshi originals) ── */
    'liberte-30ml':       { status: 'ELEGANT', statusColor: '#854F0B', scent: 'FRESH · FLORAL',    color: '#8a6f2e' },
    'noir-30ml':          { status: 'DARK',    statusColor: '#2C2C2A', scent: 'DARK · OUD',        color: '#7a5230' },
    'voyage-30ml':        { status: 'BREEZY',  statusColor: '#0F6E56', scent: 'FRESH · WOODS',     color: '#3d6b58' },

    /* ── SPRAY PERFUMES 30ml (shared fragrances, different handles) ── */
    'aqua-30ml':          { status: 'OCEAN',   statusColor: '#0C447C', scent: 'FRESH · AQUATIC',   color: '#3a6b8a' },
    'vanilla-30ml':       { status: 'COZY',    statusColor: '#993C1D', scent: 'WARM · GOURMAND',   color: '#9b7340' },
    'blue-1':             { status: 'CLEAN',   statusColor: '#085041', scent: 'CLEAN · FRESH',     color: '#3d6b8a' },
    'million-gold-30ml':  { status: 'RICH',    statusColor: '#BA7517', scent: 'SPICY · ORIENTAL',  color: '#8a5c2e' },
    'floral-1':           { status: 'BLOOM',   statusColor: '#993556', scent: 'PURE · FLORAL',     color: '#9b6b7a' },
    'oriental-30ml':      { status: 'EXOTIC',  statusColor: '#534AB7', scent: 'RICH · ORIENTAL',   color: '#8a3d5c' },
    'code-30ml':          { status: 'SWEET',   statusColor: '#D4537E', scent: 'FLORAL · ORIENTAL', color: '#8a4a7a' },
    'white-oud-2':        { status: 'EARTHY',  statusColor: '#633806', scent: 'WOODY · FLORAL',    color: '#7a6558' },

    /* ── SPRAY PERFUMES 30ml (30ml exclusives) ── */
    'desire':                        { status: 'ALLURE',  statusColor: '#8B1A4A', scent: 'WARM · SENSUAL',    color: '#9b3d6b' },
    'nargis-and-jasmine-combo-of-2': { status: 'SERENE',  statusColor: '#C0607A', scent: 'SOFT · FLORAL',     color: '#9b5c78' },
    'pink-lotus':                    { status: 'ROSY',    statusColor: '#B5394A', scent: 'RICH · FLORAL',     color: '#9b4a5c' },

    /* ── MASSAGE CANDLES (melts into warm oil for skin massage) ── */
    'live-easy-vanilla-massage-candle':      { status: 'RELAX',   statusColor: '#9B7340', scent: 'STRESS · RELIEF', color: '#7a5c2e' },
    'sleep-easy-lavender-massage-candle':    { status: 'DRIFT',   statusColor: '#6B4A9B', scent: 'SLEEP · PREP',   color: '#6b4a9b' },
    'breathe-easy-eucalyptus-massage-candle':{ status: 'OPEN',    statusColor: '#1E7056', scent: 'CHEST · RUB',    color: '#1e7056' },
    'love-easy-jasmine-massage-candle':      { status: 'ROMANCE', statusColor: '#C04060', scent: 'SKIN · GLOW',    color: '#c04060' },

    /* ── AROMATHERAPY CANDLES (burns to fill room with therapeutic aroma) ── */
    'cedarwood-aromatherapy-candle':   { status: 'GROUND',   statusColor: '#5C3A1E', scent: 'STRESS · CALM',  color: '#7a5c3a' },
    'lemon-grass-aromatherapy-candle': { status: 'ENERGIZE', statusColor: '#7A9E20', scent: 'MOOD · BOOST',   color: '#5a7a20' },
    'ylang-ylang-aromatherapy-candle': { status: 'UNWIND',   statusColor: '#C08040', scent: 'ANXIETY · EASE', color: '#8a5c2e' },
    'frankincense-aromatherapy-candle':{ status: 'MEDITATE', statusColor: '#7A4A2A', scent: 'MIND · BODY',    color: '#7a4a2a' },
    'sandalwood-aromatherapy-candle':  { status: 'PEACE',    statusColor: '#8B5A2B', scent: 'INNER · CALM',   color: '#8b5a2b' },
    'rose-aromatherapy-candle':        { status: 'LOVE',     statusColor: '#A83050', scent: 'SELF · CARE',    color: '#a83050' },
    'jasmine-aromatherapy-candle':     { status: 'UPLIFT',   statusColor: '#C67B20', scent: 'MOOD · LIFT',    color: '#8a5c20' },
    'rosemary-aromatherapy-candle':    { status: 'FOCUS',    statusColor: '#3A7A50', scent: 'MIND · SHARP',   color: '#3a7a50' },
    'eucalyptus-aromatherapy-candle':  { status: 'BREATHE',  statusColor: '#1A7060', scent: 'CLEAR · AIR',    color: '#1a7060' },
    'bergamot-aromatherapy-candle':    { status: 'EASE',     statusColor: '#5A8A20', scent: 'NERVE · CALM',   color: '#5a7a20' },
    'vanilla-aromatherapy-candle':     { status: 'COMFORT',  statusColor: '#9B4520', scent: 'WARM · SAFE',    color: '#8a5c2e' },
    'lavender-aromatic-candle':        { status: 'SLEEP',    statusColor: '#6B4A9B', scent: 'DEEP · REST',    color: '#6b4a9b' },

    /* ── SOLID PERFUMES (alcohol-free wax, applied directly to skin) ── */
    'white-oud-solid-perfume':  { status: 'EARTHY',   statusColor: '#633806', scent: 'SKIN · WARM',       color: '#7a6558' },
    'te-amo-solid-perfume':     { status: 'LOVE',     statusColor: '#B53050', scent: 'PULSE · POINT',     color: '#9b3d6b' },
    'aqua-solid-perfume':       { status: 'REFRESH',  statusColor: '#0C447C', scent: 'COOL · SKIN',       color: '#3a6b8a' },
    'woody-solid-perfume':      { status: 'ANCHOR',   statusColor: '#412402', scent: 'DEEP · WOODY',      color: '#7a4a2e' },
    'solid-perfume-black-oud':  { status: 'COMFORT',  statusColor: '#993C1D', scent: 'SKIN · SWEET',      color: '#9b7340' },
    'floral-solid-perfume':     { status: 'BLOOM',    statusColor: '#993556', scent: 'PETAL · SOFT',      color: '#9b6b7a' },
    'lavender-solid-perfume':   { status: 'CALM',     statusColor: '#6B4A9B', scent: 'SKIN · SOOTHE',     color: '#6b4a9b' },
    'chanelle-solid-perfume':   { status: 'CHIC',     statusColor: '#2A2A3A', scent: 'SIGNATURE · WEAR',  color: '#5c5c6b' },
    'aura-fresh-solid-perfume': { status: 'REVIVE',   statusColor: '#1A7A6A', scent: 'INSTANT · FRESH',   color: '#3a7a6a' },
    'rose-solid-perfume':       { status: 'GLOW',     statusColor: '#B5394A', scent: 'SKIN · RADIANCE',   color: '#9b4a5c' },
    'jasmine-solid-perfume':    { status: 'ALLURE',   statusColor: '#C67B20', scent: 'PULSE · POINT',     color: '#8a5c20' },

    /* ── REED DIFFUSERS (passive continuous home fragrance) ── */
    'harshingar-reed-diffuser-100ml':  { status: 'NIGHT',   statusColor: '#2A1A4A', scent: 'EVENING · AMBIANCE', color: '#5c4a7a' },
    'reed-diffuser-lemongrass':        { status: 'REVIVE',  statusColor: '#7A9E20', scent: 'HOME · FRESH',       color: '#5a7a20' },
    'green-tea-reed-diffuser-100ml':   { status: 'ZEN',     statusColor: '#2E6B40', scent: 'SPACE · CALM',       color: '#2e6b40' },
    'fabulous-reed-diffuser-100ml':    { status: 'VIBRANT', statusColor: '#D85A30', scent: 'BOLD · AMBIANCE',    color: '#8a5c6b' },

    /* ── ESSENTIAL OILS (therapeutic — diffuse, inhale, or dilute) ── */
    'lemongrass-100-natural-essential-oil':        { status: 'REPEL',   statusColor: '#7A9E20', scent: 'INSECT · GUARD',   color: '#5a7a20' },
    'tea-tree-100-natural-essential-oil':          { status: 'HEAL',    statusColor: '#1A7060', scent: 'ANTI · MICROBIAL', color: '#1a7060' },
    'eucalyptus-100-natural-essential-oil':        { status: 'INHALE',  statusColor: '#1E7056', scent: 'STEAM · THERAPY',  color: '#1e7056' },
    'jasmine-natural-identical-essential-oil':     { status: 'MOOD',    statusColor: '#C67B20', scent: 'EMOTION · LIFT',   color: '#8a5c20' },
    'rose-natural-identical-essential-oil':        { status: 'GLOW',    statusColor: '#B5394A', scent: 'SKIN · CARE',      color: '#9b4a5c' },
    'lemon-100-natural-essential-oil':             { status: 'DETOX',   statusColor: '#C4920A', scent: 'CLEANSE · PURIFY', color: '#8a6b20' },
    'vanilla-natural-identical-essential-oil':     { status: 'SOOTHE',  statusColor: '#993C1D', scent: 'NERVOUS · EASE',   color: '#9b7340' },
    'sandalwood-natural-identical-essential-oil':  { status: 'STILL',   statusColor: '#8B5A2B', scent: 'DEEP · MEDITATE',  color: '#8b5a2b' },
    'ylang-ylang-100-natural-essential-oil':       { status: 'BALANCE', statusColor: '#C08040', scent: 'HORMONE · AID',    color: '#8a5c2e' },
    'lavender-100-natural-essential-oil':          { status: 'RESTORE', statusColor: '#6B4A9B', scent: 'HEAL · TOPICAL',   color: '#6b4a9b' },

    /* ── CARRIER OILS (dilutes essential oils, nourishes skin) ── */
    'apricot-kernel-carrier-oil':  { status: 'SILKY',    statusColor: '#C87850', scent: 'ALL · SKIN',       color: '#9b6b40' },
    'avocado-carrier-oil':         { status: 'NOURISH',  statusColor: '#3A6B20', scent: 'DRY · SKIN',       color: '#3a6b20' },
    'jojoba-carrier-oil':          { status: 'REGULATE', statusColor: '#8B7040', scent: 'OILY · SKIN',      color: '#8b6b30' },
    'evening-primerose-carrier-oil':{ status: 'RENEW',   statusColor: '#9B3D7A', scent: 'MATURE · SKIN',    color: '#7a3d6b' },
    'rosehip-seed-carrier-oil':    { status: 'FADE',     statusColor: '#C04060', scent: 'SCAR · REPAIR',    color: '#9b4a5c' },
    'sweet-almond-carrier-oil':    { status: 'SOFTEN',   statusColor: '#C08A50', scent: 'SENSITIVE · SKIN', color: '#9b7340' },

    /* ── ATTARS 3ml (traditional concentrated oil perfume, no alcohol) ── */
    'g-flora-attar-3ml':    { status: 'BLOOM',   statusColor: '#993556', scent: 'OIL · BASE', color: '#9b6b7a' },
    'arabian-attar':        { status: 'MYSTIC',  statusColor: '#4A2070', scent: 'OIL · BASE', color: '#7a4a8a' },
    'white-oud-attar':      { status: 'EARTHY',  statusColor: '#633806', scent: 'OIL · BASE', color: '#7a6558' },
    'shanaya-attar':        { status: 'GRACE',   statusColor: '#8B1A4A', scent: 'OIL · BASE', color: '#9b3d6b' },
    'blue-d-chanel-attar':  { status: 'FRESH',   statusColor: '#085041', scent: 'OIL · BASE', color: '#3d6b8a' },
    'limitless-attar':      { status: 'BOLD',    statusColor: '#27500A', scent: 'OIL · BASE', color: '#4a7a5c' },
    'mitti-attar':          { status: 'EARTH',   statusColor: '#6B4A2E', scent: 'OIL · BASE', color: '#7a5c3a' },
    'chocolate-attar':      { status: 'INDULGE', statusColor: '#3A1A08', scent: 'OIL · BASE', color: '#7a4a2e' },
    'rose-attar':           { status: 'ROSY',    statusColor: '#B5394A', scent: 'OIL · BASE', color: '#9b4a5c' },
    'black-oud-attar':      { status: 'DARK',    statusColor: '#2C2C2A', scent: 'OIL · BASE', color: '#7a5230' },

    /* ── ATTARS 8ml ── */
    'g-flora-attar-8ml':  { status: 'BLOOM',   statusColor: '#993556', scent: 'OIL · BASE', color: '#9b6b7a' },
    'white-oud-attar-1':  { status: 'EARTHY',  statusColor: '#633806', scent: 'OIL · BASE', color: '#7a6558' },
    'attar-arabian':      { status: 'MYSTIC',  statusColor: '#4A2070', scent: 'OIL · BASE', color: '#7a4a8a' },
    'limitless-attar-1':  { status: 'BOLD',    statusColor: '#27500A', scent: 'OIL · BASE', color: '#4a7a5c' },
    'rose-attar-1':       { status: 'ROSY',    statusColor: '#B5394A', scent: 'OIL · BASE', color: '#9b4a5c' },
    'black-oud-attar-1':  { status: 'DARK',    statusColor: '#2C2C2A', scent: 'OIL · BASE', color: '#7a5230' },
    'shanaya-attar-1':    { status: 'GRACE',   statusColor: '#8B1A4A', scent: 'OIL · BASE', color: '#9b3d6b' },
    'blue-attar':         { status: 'FRESH',   statusColor: '#085041', scent: 'OIL · BASE', color: '#3d6b8a' },
    'mitti-attar-1':      { status: 'EARTH',   statusColor: '#6B4A2E', scent: 'OIL · BASE', color: '#7a5c3a' },
    'chocolate-attar-1':  { status: 'INDULGE', statusColor: '#3A1A08', scent: 'OIL · BASE', color: '#7a4a2e' },

    /* ── BUNDLES ── */
    'scent-wardrobe':           { status: 'COLLECT', statusColor: '#534AB7', scent: 'GIFT · SET',    color: '#5c4a8a' },
    'premium-gifting-set':      { status: 'GIFT',    statusColor: '#BA7517', scent: 'PREMIUM · SET', color: '#8a5c2e' },
    'fragrance-explorer-bundle':{ status: 'EXPLORE', statusColor: '#0F6E56', scent: 'TRIAL · SET',   color: '#3d6b58' },
    'signature-edp-duo':        { status: 'DUO',     statusColor: '#185FA5', scent: 'PAIR · SET',    color: '#3a5c8a' },
    'attar-trio-bundle':        { status: 'TRIO',    statusColor: '#7A4A2A', scent: 'ATTAR · SET',   color: '#7a4a2a' },

    /* ── MISC ── */
    'rose-water-ethically-harvested': { status: 'TONE', statusColor: '#C04060', scent: 'SKIN · MIST',    color: '#9b4a5c' },
    'pine-needle-eco-planter-small-100-natural-biodegradable-set-of-2-small': { status: 'ECO', statusColor: '#27500A', scent: 'BIO · FRIENDLY', color: '#3a7a50' }
  };

  function injectStyle() {
    if (document.getElementById('kankshi-badges-css')) return;
    var el = document.createElement('style');
    el.id = 'kankshi-badges-css';
    el.textContent =
      '.kankshi-badge-wrap{position:absolute;top:10px;left:10px;z-index:10;display:block;pointer-events:none;}' +
      '.kankshi-badge-new{color:#fff;font-size:9px;font-weight:600;padding:3px 9px;border-radius:2px;letter-spacing:.09em;display:block;width:fit-content;line-height:1.4;font-family:sans-serif;margin-bottom:4px;}' +
      '.kankshi-badge-scent{background:transparent;font-size:8px;font-weight:500;padding:2px 7px;border-radius:2px;letter-spacing:.06em;display:block;width:fit-content;border:0.5px solid;line-height:1.4;font-family:sans-serif;}' +
      '.kankshi-badge-wrap--pdp .kankshi-badge-new{font-size:13px;padding:5px 13px;margin-bottom:6px;}' +
      '.kankshi-badge-wrap--pdp .kankshi-badge-scent{font-size:11px;padding:4px 10px;}';
    document.head.appendChild(el);
  }

  /* ── Collection grid badges ── */
  function injectBadges() {
    document.querySelectorAll('li.grid__item').forEach(function (item) {
      if (item.querySelector('.kankshi-badge-wrap')) return;
      var link = item.querySelector('a.full-unstyled-link');
      if (!link) return;
      var handle = (link.getAttribute('href') || '').replace('/products/', '');
      var badge = BADGES[handle];
      if (!badge) return;
      var cardInner = item.querySelector('.card__inner') || item.querySelector('.card-wrapper');
      if (!cardInner) return;
      cardInner.style.position = 'relative';
      var wrap = makeBadgeWrap(badge);
      cardInner.appendChild(wrap);
    });
  }

  /* ── Product detail page badge ── */
  function injectProductPageBadge() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    var handle = match[1];
    var badge = BADGES[handle];
    if (!badge) return;
    if (document.querySelector('.kankshi-badge-wrap')) return;

    /* Walk down to the actual image box of the FIRST media item so the
       badge is anchored to the image corner, not to a wider parent. */
    var firstItem =
      document.querySelector('ul.product__media-list li:first-child') ||
      document.querySelector('li.product__media-item--first') ||
      document.querySelector('li.product__media-item');

    var container = null;
    if (firstItem) {
      container =
        firstItem.querySelector('.product__media') ||
        firstItem.querySelector('[data-media-type]') ||
        firstItem;
    } else {
      /* Fallback for non-Dawn themes */
      container =
        document.querySelector('.product__media') ||
        document.querySelector('.product-featured-img')?.parentElement ||
        document.querySelector('.product-single__photos');
    }

    if (!container) return;
    container.style.position = 'relative';
    var wrap = makeBadgeWrap(badge);
    wrap.classList.add('kankshi-badge-wrap--pdp');
    container.appendChild(wrap);
  }

  function makeBadgeWrap(badge) {
    var wrap = document.createElement('div');
    wrap.className = 'kankshi-badge-wrap';
    var nb = document.createElement('span');
    nb.className = 'kankshi-badge-new';
    nb.style.background = badge.statusColor;
    nb.textContent = badge.status;
    var sb = document.createElement('span');
    sb.className = 'kankshi-badge-scent';
    sb.style.color = badge.color;
    sb.style.borderColor = badge.color;
    sb.textContent = badge.scent;
    wrap.appendChild(nb);
    wrap.appendChild(sb);
    return wrap;
  }

  /* ── Homepage Bestseller section purpose badges ── */
  function injectHomepageBadges() {
    document.querySelectorAll('.productssection .product-card').forEach(function (card) {
      if (card.querySelector('.kankshi-badge-wrap')) return;
      var href = (card.getAttribute('href') || '').replace('https://kankshi.co.in', '');
      var handle = href.replace('/products/', '').split('?')[0];
      var badge = BADGES[handle];
      if (!badge) return;
      var imgDiv = card.querySelector('.product-img');
      if (!imgDiv) return;
      imgDiv.style.position = 'relative';
      var wrap = makeBadgeWrap(badge);
      /* Purpose badge sits at bottom-left; star badge occupies top-left */
      wrap.style.top = 'auto';
      wrap.style.bottom = '8px';
      imgDiv.appendChild(wrap);
    });
  }

  function init() {
    injectStyle();
    injectBadges();
    injectProductPageBadge();
    injectHomepageBadges();
    new MutationObserver(function () {
      injectBadges();
      injectProductPageBadge();
      injectHomepageBadges();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
